import { SystemFuncArgs } from '@brochington/ecstatic';
import CarnivoreDoc from 'editor/components/CarnivoreDoc';
import CarnivoreSheet from 'editor/components/CarnivoreSheet';
import { Components } from '../components';
import UpdateZoom from '../components/UpdateZoom';

export const updateZoomComponents = [CarnivoreDoc, UpdateZoom];

export function updateZoom(args: SystemFuncArgs<Components>): void {
  const { entity, components, world } = args;
  const carnDoc = entity.get(CarnivoreDoc);
  const { doc } = carnDoc;
  const sheetComp = world.grab(CarnivoreSheet)?.component;
  if (!sheetComp) {
    return;
  }
  const { sheet } = sheetComp;
  const { direction } = components.get(UpdateZoom);

  switch (direction) {
    case 'in':
      doc.zoom(1.5);
      break;

    case 'out':
      if (doc.transform[0] > 0) {
        doc.zoom(0.5);
      }
      break;
    case 'full':
      doc.zoomFullOnSheet(sheet.id);
      break;
    case 'pinchZoomIn':
      doc.zoom(1.05);
      break;
    case 'pinchZoomOut':
      if (doc.transform[0] > 0) {
        doc.zoom(0.95);
      }
      break;

    default:
  }

  entity.destroy();
}
